<template>
  <div>
    <div id="gantt-content" class="flex">
      <div id="gantt-task">
        <div id="gantt-task-title" class="flex items-center bg-green-600 text-white h-20" ref="task">
          <div class="border-t border-r border-b flex items-center justify-center font-bold text-xs w-28 h-full">作業名</div>
          <div class="border-t border-r border-b flex items-center justify-center font-bold text-xs w-28 h-full">タスク</div>
          <div class="border-t border-r border-b flex items-center justify-center font-bold font-size-10 w-8 h-full">
            <div>
              <span>予定</span><br>
              <span>実績</span>
            </div>
          </div>
          <div class="border-t border-r border-b flex items-center justify-center font-bold font-size-10 w-50px h-full">出勤時間</div>
          <div class="border-t border-r border-b flex items-center justify-center font-bold font-size-10 w-50px h-full">退勤時間</div>
          <div class="border-t border-r border-b flex items-center justify-center font-bold text-xs w-5-characters h-full">担当</div>
        </div>
        <div id="gantt-task-list" class="overflow-y-hidden" :style="`height:${calendarViewHeight}px`">
          <template v-if="applyFilters">
            <div class="flex h-10 border-b">
              <div class="border-r flex items-center font-bold w-28 text-xs pl-4">
                検索
              </div>
              <div class="border-r flex items-center justify-center w-28 text-xm flex-col first-filter">
                <SelectListDialog
                    v-model="selectedFilterGreencTaskId"
                    :select-list="greencTasksList"
                    title="作業名"
                />
              </div>
              <div class="border-r flex items-center justify-center w-8 text-xm flex-col first-filter">
                <SelectListDialog
                    v-model="selectedFilterChildTaskWorkTypeId"
                    :select-list="greenc_child_task_work_typeList"
                    title="予定実績"
                />
              </div>
              <div class="border-r flex items-center justify-center w-50px text-xm flex-col first-filter">
<!--                <TimePickerDialog-->
<!--                    v-model="selectedFilterStartTime"-->
<!--                    title="出勤時間"-->
<!--                />-->
              </div>
              <div class="border-r flex items-center justify-center w-50px text-xm flex-col first-filter">
<!--                <TimePickerDialog-->
<!--                    v-model="selectedFilterEndTime"-->
<!--                    title="退勤時間"-->
<!--                />-->
              </div>
              <div class="flex items-center justify-center w-5-characters text-xm flex-col first-filter">
                <SelectListDialog
                    v-model="selectedFilterUserId"
                    :select-list="usersList"
                    title="担当"
                />
              </div>
            </div>
          </template>


          <div v-for="(task,index) in displayTasks" :key="`tasks-${index}`"
               class="flex h-10 border-b"
               @dragstart="dragTask(task)"
               @dragover.prevent="dragTaskOver(task)"
               :draggable="false"
          >
            <template v-if="task.cat === 'category' && categories.length > 0">
              <div class="flex items-center font-bold w-full text-sm pl-2 flex justify-between items-center bg-teal-100">
                <span>{{task.name}}</span>
                <div class="pr-4" @click="toggleCategory(task.id)">
                  <span v-if="task.collapsed">
                    <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </span>
                  <span v-else>
                    <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="flex"
                   @click="editTask(task)"
                   :class="{'stop-click-event': !clickable}"
                   style="cursor: pointer"
              >
                <div class="border-l border-r flex items-center justify-start w-28 text-sm textEllipsis pl-1 text-wrap font-size-12">
                  {{cutText(task.name, 10)}}
                </div>
                <div class="border-l border-r flex items-center justify-start w-28 text-sm textEllipsis pl-1 font-size-12">
                  {{cutText(task.greenc_task_name, 9)}}
                </div>
                <div class="border-r flex items-center justify-center w-8 text-sm font-size-12">
                  {{task.greenc_child_task_work_type_name}}
                </div>
                <div class="border-r flex items-center justify-center w-50px text-sm font-size-12">
                  {{formatTime(task.start_time)}}
                </div>
                <div class="border-r flex items-center justify-center w-50px text-sm font-size-12">
                  {{formatTime(task.end_time)}}
                </div>
                <div class="border-r flex items-center text-sm pl-1 w-5-characters textEllipsis font-size-12">
                  {{task.user_name}}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div id="gantt-calendar" class="overflow-x-scroll overflow-y-hidden border-l"
           :style="`width:${calendarViewWidth}px`" ref="calendar">
        <div id="gantt-date" class="h-20">
          <!-- Year/Month/Date headers -->
          <div id="gantt-year-month" class="relative h-8">
            <div v-for="(dateInfo, index) in displayDates" :key="`date-${index}`"
                 class="bg-indigo-700 text-white border-b border-r border-t h-8 absolute font-bold text-sm flex items-center justify-center"
                 :style="`width:${24*block_size}px;left:${index*24*block_size}px`">
              {{formatDisplayDate(dateInfo.date)}}
            </div>
          </div>
          <!-- Hour headers -->
          <div id="gantt-day" class="relative h-12">
            <div v-for="(dateInfo, dateIndex) in displayDates" :key="`date-hours-${dateIndex}`">
              <div v-for="hour in 24" :key="`hour-${dateIndex}-${hour-1}`">
                <div class="border-r border-b h-12 absolute flex items-center justify-center flex-col font-bold text-xs"
                     :class="{'bg-yellow-100': isCurrentHour(dateInfo.date, hour-1)}"
                     :style="`width:${block_size}px;left:${(dateIndex*24 + hour-1)*block_size}px`">
                  <span>{{ hour-1 }}時</span>
                </div>
              </div>
            </div>
          </div>

          <template v-if="applyFilters">
            <div id="gantt-day-2" class="relative h-10" :style="{zIndex: !showEditDialog ? 10000 : 0}">
              <div v-for="(dateInfo, dateIndex) in displayDates" :key="`date-hours-${dateIndex}`">
                <div v-for="hour in 24" :key="`hour-${dateIndex}-${hour-1}`">
                  <div class="border-r border-b h-10 absolute flex items-center justify-center flex-col font-bold text-xs"
                       :style="`width:${block_size}px;left:${(dateIndex*24 + hour-1)*block_size}px`">
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- Grid lines -->
          <div id="gantt-height" class="relative">
            <div v-for="(dateInfo, dateIndex) in displayDates" :key="`date-grid-${dateIndex}`">
              <div v-for="hour in 24" :key="`grid-hour-${dateIndex}-${hour-1}`">
                <div class="border-r border-b absolute"
                     :style="`width:${block_size}px;left:${(dateIndex*24 + hour-1)*block_size}px;height:${calendarViewHeight}px`">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="gantt-bar-area" class="relative"
             :style="`width:${totalCalendarWidth}px;height:${calendarViewHeight}px`">

          <!-- Add horizontal grid lines for task rows -->
          <div v-for="(task, index) in displayTasks" :key="`task-grid-${index}`"
               class="absolute"
               :class="{
                 'border-b border-gray-200': task.cat === 'category',
                 'border-b': task.cat !== 'category',
                 'border-t border-t-gray-400': index > 0 && displayTasks[index-1].cat === 'category'
               }"
               :style="`width:${totalCalendarWidth}px;height:40px;top:${index * 40}px`">
          </div>

          <div v-for="(bar,index) in taskBars" :key="bar.task.cat === 'task' ? `task-bar-${bar.task.id}` : `category-bar-${bar.task.id || index}`">
            <div :style="bar.style" class="rounded-lg absolute h-5 bg-yellow-500" v-if="bar.task.cat === 'task'"
                 @mousedown="mouseDownMove(bar.task)">

              <!-- Break time overlay -->
              <div v-if="bar.breakOverlay"
                   class="absolute bg-red-500 rounded-lg h-full pointer-events-none"
                   :style="bar.breakOverlay.style">
              </div>

              <div v-if="resizable" class="absolute w-2 h-2 bg-gray-300 border border-black"
                   style="top:6px;left:-6px;cursor:col-resize"
                   @mousedown.stop="mouseDownResize(bar.task,'left')">
              </div>
              <div v-if="resizable" class="absolute w-2 h-2 bg-gray-300 border border-black"
                   style="top:6px;right:-6px;cursor:col-resize"
                   @mousedown.stop="mouseDownResize(bar.task,'right')">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import TimePickerDialog from '@/components/CDialogCustomTimePicker.vue'
import SelectListDialog from "@/components/CDialogSelectList.vue";
export default {
  name: 'TimeBasedGanttChart',
  components: {SelectListDialog},
  props: {
    tasksList: {
      type: Array,
      default: () => [],
    },
    block_size: {
      default: 60
    },
    categories: {
      type: Array,
      default: () => []
    },
    clickable: {
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    resizable: {
      type: Boolean,
      default: false
    },
    displayDate: {
      type: String,
      default: null
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null
    },
    applyFilters: {
      type: Boolean,
      default: false
    },
    usersList: {
      type: Array,
      default: () => [],
    },
    greencTasksList: {
      type: Array,
      default: () => [],
    },
    showEditDialog: {
      type: Boolean,
      default: false
    },
    greenc_child_task_work_typeList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      tasks: [],
      inner_width: '',
      inner_height: '',
      task_width: '',
      task_height: '',
      position_id: 0,
      today: this.$moment(),
      dragging: false,
      pageX: '',
      element: '',
      left: '',
      width: '',
      leftResizing: false,
      rightResizing: false,
      task_id: '',
      currentDisplayDate: null,
      dragTaskDate: null,
      selectedFilterStartTime: null,
      selectedFilterEndTime: null,
      selectedFilterUserId: null,
      selectedFilterChildTaskWorkTypeId: null,
      selectedFilterGreencTaskId: null,
    }
  },
  methods: {
    cutText(txt,len) {
      const str = txt;
      if(this.isString(str) === true) {
        if(str.length > len){
          return str.substring(0, (len - 1))+'...';
        }
        else {
          return str;
        }
      }
      else {
        return "";
      }
    },
    isString(value) {
      return typeof value === "string" || value instanceof String;
    },
    countZH(str) {
      let len = 0;
      for (let i = 0; i < str.length; i++) {
        (str[i].match(/[ -~]/)) ? len += 1 : len += 2;
      }
      return len;
    },
    // Common date and time conversion methods
    parseDateTime(dateTime) {
      if (!dateTime) return this.$moment();

      if (typeof dateTime === 'string' && /^\d{1,2}:\d{2}(:\d{2})?$/.test(dateTime)) {
        return this.$moment(dateTime, 'HH:mm:ss');
      }

      return this.$moment(dateTime);
    },

    formatTime(time) {
      if (!time) return '';
      const momentTime = this.parseDateTime(time);
      return momentTime.format('HH:mm');
    },

    formatDisplayDate(date) {
      const momentDate = this.$moment(date);
      const dayNames = ['日', '月', '火', '水', '木', '金', '土'];
      const dayOfWeek = dayNames[momentDate.day()];
      return `${momentDate.format('YYYY年MM月DD日')} (${dayOfWeek})`;
    },

    getTimeInHours(time) {
      const momentTime = this.parseDateTime(time);
      return momentTime.hour() + (momentTime.minute() / 60);
    },

    hoursToTimeString(hours) {
      const hour = Math.floor(hours);
      const minute = Math.round((hours - hour) * 60);
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    },

    calculateBreakOverlay(task) {
      if (!task.break_start_time || !task.break_end_time) {
        return null;
      }

      const taskStartHours = this.getTimeInHours(task.start_time);
      const taskEndHours = this.getTimeInHours(task.end_time);
      const breakStartHours = this.getTimeInHours(task.break_start_time);
      const breakEndHours = this.getTimeInHours(task.break_end_time);

      if (breakStartHours < taskStartHours || breakEndHours > taskEndHours || breakStartHours >= breakEndHours) {
        return null;
      }

      const taskDuration = taskEndHours - taskStartHours;
      const breakDuration = breakEndHours - breakStartHours;
      const breakStartOffset = breakStartHours - taskStartHours;

      const breakLeftPercentage = (breakStartOffset / taskDuration) * 100;
      const breakWidthPercentage = (breakDuration / taskDuration) * 100;

      return {
        style: {
          left: `${breakLeftPercentage}%`,
          width: `${breakWidthPercentage}%`,
          top: '0px'
        }
      };
    },

    isCurrentHour(date, hour) {
      const currentDate = this.$moment().format('YYYY-MM-DD');
      const displayDate = this.$moment(date).format('YYYY-MM-DD');

      if (currentDate === displayDate) {
        return this.today.hour() === hour;
      }
      return false;
    },

    getDateIndexForTask(task) {
      // Find which date this task belongs to
      if (!task.task_date) return 0;

      const taskDate = this.$moment(task.task_date).format('YYYY-MM-DD');
      const dateIndex = this.displayDates.findIndex(d =>
          this.$moment(d.date).format('YYYY-MM-DD') === taskDate
      );

      return Math.max(0, dateIndex);
    },

    getWindowSize() {
      if (this.$refs.task) {
        this.inner_width = window.innerWidth;
        this.inner_height = window.innerHeight;
        this.task_width = this.$refs.task.offsetWidth;
        this.task_height = this.$refs.task.offsetHeight;
      }
    },

    scrollToCurrentTime() {
      const currentDateStr = this.$moment().format('YYYY-MM-DD');
      const currentDateIndex = this.displayDates.findIndex(d =>
          this.$moment(d.date).format('YYYY-MM-DD') === currentDateStr
      );

      if (currentDateIndex >= 0) {
        const currentHour = this.today.hour();
        const scrollPosition = (currentDateIndex * 24 + currentHour) * this.block_size - this.calendarViewWidth / 2;
        this.$refs.calendar.scrollLeft = Math.max(0, scrollPosition);
      } else if (this.displayDates.length > 0) {
        // Scroll to first date if current date is not in range
        const scrollPosition = 12 * this.block_size; // Scroll to noon of first date
        this.$refs.calendar.scrollLeft = scrollPosition;
      }
    },

    windowSizeCheck() {
      let height = this.lists.length - this.position_id;
      if (event.deltaY > 0 && height * 40 > this.calendarViewHeight) {
        this.position_id++;
      } else if (event.deltaY < 0 && this.position_id !== 0) {
        this.position_id--;
      }
    },

    mouseDownMove(task) {
      if (this.draggable) {
        this.dragging = true;
        this.pageX = event.pageX;
        this.element = event.target;
        this.left = event.target.style.left;
        this.task_id = task.id;
        this.dragTaskDate = task.task_date; // Store the task's original date
      }
    },

    mouseMove() {
      if (this.dragging) {
        let diff = this.pageX - event.pageX;
        let newLeft = parseInt(this.left.replace('px', '')) - diff;

        // Calculate constraints based on task's date
        const dateIndex = this.getDateIndexForTask({ task_date: this.dragTaskDate });
        const dateStartPixel = dateIndex * 24 * this.block_size;
        const dateEndPixel = (dateIndex + 1) * 24 * this.block_size;
        const taskWidth = parseInt(this.element.style.width.replace('px', ''));

        // Constrain movement within the task's date
        newLeft = Math.max(dateStartPixel, Math.min(dateEndPixel - taskWidth, newLeft));

        this.element.style.left = `${newLeft}px`;
      }
    },

    stopDrag() {
      let taskToEmit = null;

      if (this.dragging) {
        let task = this.tasks.find(task => task.id === this.task_id);

        if (!task) {
          this.dragging = false;
          return;
        }

        // Calculate the actual movement based on current element position vs original position
        const originalLeft = parseInt(this.left.replace('px', ''));
        const currentLeft = parseInt(this.element.style.left.replace('px', ''));
        const actualMovementPixels = originalLeft - currentLeft;
        const actualMovementHours = actualMovementPixels / this.block_size;

        // Snap to 15-minute intervals (0.25 hours)
        const snappedMovementHours = Math.round(actualMovementHours / 0.25) * 0.25;

        // Only update times if there was actual movement
        if (Math.abs(snappedMovementHours) > 0.01) {
          let startHours = this.getTimeInHours(task.start_time) - snappedMovementHours;
          let endHours = this.getTimeInHours(task.end_time) - snappedMovementHours;

          // Ensure times are within 0-24 hour range
          startHours = Math.max(0, Math.min(23.99, startHours));
          endHours = Math.max(0, Math.min(23.99, endHours));

          task.start_time = this.hoursToTimeString(startHours);
          task.end_time = this.hoursToTimeString(endHours);

          // Also adjust break times if they exist
          if (task.break_start_time && task.break_end_time) {
            let breakStartHours = this.getTimeInHours(task.break_start_time) - snappedMovementHours;
            let breakEndHours = this.getTimeInHours(task.break_end_time) - snappedMovementHours;

            breakStartHours = Math.max(0, Math.min(23.99, breakStartHours));
            breakEndHours = Math.max(0, Math.min(23.99, breakEndHours));

            task.break_start_time = this.hoursToTimeString(breakStartHours);
            task.break_end_time = this.hoursToTimeString(breakEndHours);
          }

          taskToEmit = task;
        }
      }

      if (this.leftResizing) {
        let diff = this.pageX - event.pageX;
        let hours = diff / this.block_size;

        // Snap to 15-minute intervals (0.25 hours)
        let snappedHours = Math.round(hours / 0.25) * 0.25;

        if (Math.abs(snappedHours) > 0.01) {
          let task = this.tasks.find(task => task.id === this.task_id);
          let startHours = this.getTimeInHours(task.start_time) - snappedHours;
          let endHours = this.getTimeInHours(task.end_time);

          // Ensure start time doesn't go below 0 or beyond end time
          startHours = Math.max(0, Math.min(endHours - 0.25, startHours));

          task.start_time = this.hoursToTimeString(startHours);
          taskToEmit = task;
        } else {
          this.element.style.width = this.width;
          this.element.style.left = `${this.left.replace('px', '')}px`;
        }
      }

      if (this.rightResizing) {
        let diff = this.pageX - event.pageX;
        let hours = diff / this.block_size;

        // Snap to 15-minute intervals (0.25 hours)
        let snappedHours = Math.round(hours / 0.25) * 0.25;

        if (Math.abs(snappedHours) > 0.01) {
          let task = this.tasks.find(task => task.id === this.task_id);
          let startHours = this.getTimeInHours(task.start_time);
          let endHours = this.getTimeInHours(task.end_time) - snappedHours;

          // Ensure end time doesn't go beyond 24 hours or before start time
          endHours = Math.max(startHours + 0.25, Math.min(23.99, endHours));

          task.end_time = this.hoursToTimeString(endHours);
          taskToEmit = task;
        } else {
          this.element.style.width = this.width;
        }
      }

      if (taskToEmit !== null) {
        this.$emit('taskUpdated', taskToEmit);
      }

      this.dragging = false;
      this.leftResizing = false;
      this.rightResizing = false;
      this.dragTaskDate = null;
    },

    mouseDownResize(task, direction) {
      if (this.resizable) {
        direction === 'left' ? this.leftResizing = true : this.rightResizing = true;
        this.pageX = event.pageX;
        this.width = event.target.parentElement.style.width;
        this.left = event.target.parentElement.style.left;
        this.element = event.target.parentElement;
        this.task_id = task.id;
        this.dragTaskDate = task.task_date;
      }
    },

    mouseResize() {
      if (this.leftResizing) {
        let diff = this.pageX - event.pageX;
        let newWidth = parseInt(this.width.replace('px', '')) + diff;
        let newLeft = parseInt(this.left.replace('px', '')) - diff;

        // Get date constraints
        const dateIndex = this.getDateIndexForTask({ task_date: this.dragTaskDate });
        const dateStartPixel = dateIndex * 24 * this.block_size;

        // Ensure resize doesn't go outside date boundary
        if (newWidth > this.block_size * 0.5 && newLeft >= dateStartPixel) {
          this.element.style.width = `${newWidth}px`;
          this.element.style.left = `${newLeft}px`;
        }
      }

      if (this.rightResizing) {
        let diff = this.pageX - event.pageX;
        let newWidth = parseInt(this.width.replace('px', '')) - diff;

        // Get date constraints
        const dateIndex = this.getDateIndexForTask({ task_date: this.dragTaskDate });
        const dateEndPixel = (dateIndex + 1) * 24 * this.block_size;
        const currentLeft = parseInt(this.element.style.left.replace('px', ''));

        // Ensure resize doesn't go outside date boundary
        if (newWidth > this.block_size * 0.5 && (currentLeft + newWidth) <= dateEndPixel) {
          this.element.style.width = `${newWidth}px`;
        }
      }
    },

    dragTask(dragTask) {
      this.task = dragTask;
    },

    toggleCategory(task_id) {
      let category = this.categories.find(category => category.id === task_id);
      if (category) {
        category.collapsed = !category.collapsed;
      }
    },

    editTask(task) {
      if (this.clickable) {
        this.$emit('editTask', task);
      }
    },

    dragTaskOver(overTask) {
      if (this.draggable && this.task) {
        let deleteIndex;
        let addIndex;
        if (this.task.cat !== 'category') {
          if (overTask.cat === 'category') {
            let updateTask = this.tasks.find(task => task.id === this.task.id);
            if (updateTask) {
              updateTask.category_id = overTask.id;
            }
          } else {
            if (overTask.id !== this.task.id) {
              this.tasks.map((task, index) => { if (task.id === this.task.id) deleteIndex = index });
              this.tasks.map((task, index) => { if (task.id === overTask.id) addIndex = index });
              this.tasks.splice(deleteIndex, 1);
              this.task.category_id = overTask.category_id;
              this.tasks.splice(addIndex, 0, this.task);
            }
          }
        }
      }
    },

    initialize() {
      this.getWindowSize();
      this.$nextTick(() => {
        if (this.autoScroll) {
          this.scrollToCurrentTime();
        }
      });

      window.addEventListener('resize', this.getWindowSize);
      window.addEventListener('wheel', this.windowSizeCheck);
      window.addEventListener('mousemove', this.mouseMove);
      window.addEventListener('mouseup', this.stopDrag);
      window.addEventListener('mousemove', this.mouseResize);
    }
  },
  computed: {
    // Determine which dates to display
    displayDates() {
      const dates = [];

      // Determine date range based on props
      let start, end;

      if (this.startDate && this.endDate) {
        // Both dates provided - show range
        start = this.$moment(this.startDate);
        end = this.$moment(this.endDate);
      } else if (this.startDate && !this.endDate) {
        // Only start date - show just that date
        start = this.$moment(this.startDate);
        end = this.$moment(this.startDate);
      } else if (!this.startDate && this.endDate) {
        // Only end date - show just that date
        start = this.$moment(this.endDate);
        end = this.$moment(this.endDate);
      } else if (this.displayDate) {
        // Legacy displayDate prop
        start = this.$moment(this.displayDate);
        end = this.$moment(this.displayDate);
      } else {
        // No dates provided - show current date
        start = this.$moment();
        end = this.$moment();
      }

      // Generate array of dates
      let current = start.clone();
      while (current.isSameOrBefore(end, 'day')) {
        dates.push({
          date: current.format('YYYY-MM-DD'),
          moment: current.clone()
        });
        current.add(1, 'day');
      }

      return dates;
    },

    totalCalendarWidth() {
      return this.displayDates.length * 24 * this.block_size;
    },

    filteredTasks() {
      // Filter tasks based on the date range being displayed
      const displayDateStrings = this.displayDates.map(d => d.date);

      const anyHasTaskDate = this.tasks.some(t => typeof t.task_date !== 'undefined' && t.task_date !== null && t.task_date !== '');
      if (!anyHasTaskDate) {
        return this.tasks;
      }

      return this.tasks.filter(t => {
        // Check task date
        if (!t.task_date) return false;
        const tDate = this.$moment(t.task_date).format('YYYY-MM-DD');
        if (!displayDateStrings.includes(tDate)) return false;

        // Check user_id filter
        if (this.selectedFilterUserId && parseInt(t.user_id) !== parseInt(this.selectedFilterUserId)) {
          return false;
        }

        // Check greenc_task_id filter
        if (this.selectedFilterGreencTaskId && parseInt(t.greenc_task_id) !== parseInt(this.selectedFilterGreencTaskId)) {
          return false;
        }

        // Check child_task_work_type_id filter
        if (this.selectedFilterChildTaskWorkTypeId && parseInt(t.greenc_child_task_work_type_id) !== parseInt(this.selectedFilterChildTaskWorkTypeId)) {
          return false;
        }

        return true;
      });
    },

    calendarViewWidth() {
      return this.inner_width - this.task_width;
    },

    calendarViewHeight() {
      return this.inner_height - this.task_height - 48 - 20;
    },

    lists() {
      let lists = [];

      if (this.categories.length === 0) {
        return this.filteredTasks.map(task => ({ cat: 'task', ...task }));
      }

      this.categories.map(category => {
        const hasTasks = this.filteredTasks.some(task => task.category_id === category.id);
        if (!hasTasks) {
          // Skip categories with no tasks
          return;
        }
        lists.push({ cat: 'category', ...category });
        this.filteredTasks.map(task => {
          if (task.category_id === category.id && !category.collapsed) {
            lists.push({ cat: 'task', ...task });
          }
        });
      });

      return lists;
    },

    displayTasks() {
      let display_task_number = Math.floor(this.calendarViewHeight / 40);
      return this.lists.slice(this.position_id, this.position_id + display_task_number);
    },

    taskBars() {
      if (!this.displayTasks || this.displayTasks.length === 0) {
        return [];
      }

      const bars = [];

      this.displayTasks.forEach((task, displayIndex) => {
        if (task.cat === 'task' && task.start_time && task.end_time && task.task_date) {
          // Find which date this task belongs to
          const taskDate = this.$moment(task.task_date).format('YYYY-MM-DD');
          const dateIndex = this.displayDates.findIndex(d => d.date === taskDate);

          if (dateIndex === -1) return; // Task date not in display range

          const startHours = this.getTimeInHours(task.start_time);
          const endHours = this.getTimeInHours(task.end_time);
          const duration = endHours - startHours;

          // Validate times
          if (isNaN(startHours) || isNaN(endHours) || duration <= 0) {
            return;
          }

          // Calculate position including date offset
          const dateOffsetPixels = dateIndex * 24 * this.block_size;
          const left = dateOffsetPixels + (startHours * this.block_size);
          const width = duration * this.block_size;
          const top = 10 + (displayIndex * 40) + (this.applyFilters ? 40 : 0);

          const bar = {
            style: {
              top: `${top}px`,
              left: `${left}px`,
              width: `${Math.max(width, this.block_size * 0.5)}px`,
            },
            task
          };

          // Calculate break overlay if break times exist
          const breakOverlay = this.calculateBreakOverlay(task);
          if (breakOverlay) {
            bar.breakOverlay = breakOverlay;
          }

          bars.push(bar);
        }
      });

      return bars;
    },
  },
  beforeMount() {
    this.tasks = [...this.tasksList];
    this.currentDisplayDate = this.displayDate ? this.$moment(this.displayDate) : this.$moment();
  },
  mounted() {
    this.initialize();
  },
  watch: {
    tasksList: {
      handler(newTasks) {
        this.tasks = [...newTasks];
      },
      deep: true,
    },
    displayDate: {
      handler(newDate) {
        this.currentDisplayDate = newDate ? this.$moment(newDate) : this.$moment();
      }
    },
    startDate: {
      handler() {
        // Re-scroll when date range changes
        this.$nextTick(() => {
          if (this.autoScroll) {
            this.scrollToCurrentTime();
          }
        });
      }
    },
    endDate: {
      handler() {
        // Re-scroll when date range changes
        this.$nextTick(() => {
          if (this.autoScroll) {
            this.scrollToCurrentTime();
          }
        });
      }
    }
  }
}
</script>

<style scoped>
.stop-click-event {
  pointer-events: none;
}
.w-50px {
  width: 50px;
}
.font-size-10 {
  font-size: 10px;
}
.font-size-12 {
  font-size: 12px;
}
.w-5-characters {
  width: 85px !important;
}
.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>